// import React, { useState, useEffect } from "react";
// import UserSidebar from "./UserSidebar";
// import InviteModal from "../../components/InviteModal";
// import AcceptInviteModal from "../../components/AcceptInviteModal";
// import ChessGameRoom from "./ChessGameRoom";
// import ChessGameVsComputer from "./ChessGameVsComputer";
// import toast from "react-hot-toast";
// import {
//   doc,
//   updateDoc,
//   getDoc,
//   collection,
//   addDoc,
//   query,
//   where,
//   getDocs,
//   deleteDoc,
//   runTransaction,
//   onSnapshot,
// } from "firebase/firestore";
// import { db } from "../../firebase";

// // --- Waiting Room Modal ---
// function WaitingRoomModal({ open, onCancel }) {
//   if (!open) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
//       <div className="bg-slate-900 rounded-2xl border-2 border-lime-400 p-8 max-w-xs w-full flex flex-col items-center">
//         <div className="text-lime-400 font-bold text-xl mb-2">
//           Waiting for Opponent...
//         </div>
//         <div className="mb-3 text-slate-200">
//           You'll be matched automatically when another player enters the same
//           bet.
//         </div>
//         <button
//           onClick={onCancel}
//           className="w-full bg-slate-700 hover:bg-slate-800 text-white rounded-xl px-6 py-2 mt-2"
//         >
//           Cancel & Leave Waiting Room
//         </button>
//       </div>
//     </div>
//   );
// }

// export default function ChessLobbyPage({
//   onlineUsers,
//   invites,
//   onInvite,
//   onDecline,
//   currentGameId,
//   user,
//   setCurrentGameId,
//   busyUserIds = [],
//   balance,
// }) {
//   // --- State ---
//   const [vsComputer, setVsComputer] = useState(false);
//   const [inviteModalOpen, setInviteModalOpen] = useState(false);
//   const [inviteTarget, setInviteTarget] = useState(null);
//   const [acceptModalOpen, setAcceptModalOpen] = useState(false);
//   const [pendingInviteData, setPendingInviteData] = useState(null);
//   const [waitingGameId, setWaitingGameId] = useState(null);

//   const isWaitingForQuickPlay = !!waitingGameId;

//   // console.log("currentGameId chess", currentGameId);

//   // --- Show Accept Modal for invites sent to you ---
//   useEffect(() => {
//     if (invites && invites.length > 0) {
//       const myPendingInvite = invites
//         .filter((inv) => inv.status === "pending" && inv.to === user.uid)
//         .sort((a, b) => b.createdAt - a.createdAt)[0];
//       if (
//         myPendingInvite &&
//         (!pendingInviteData ||
//           pendingInviteData.inviteId !== myPendingInvite.inviteId)
//       ) {
//         setPendingInviteData(myPendingInvite);
//         setAcceptModalOpen(true);
//       }
//     }
//   }, [invites, user, pendingInviteData]);

//   // --- Listen for being matched while waiting ---
//   useEffect(() => {
//     if (!waitingGameId || !user?.uid) return;
//     const q = query(
//       collection(db, "games"),
//       where("players", "array-contains", user.uid),
//       where("status", "==", "active"),
//       where("type", "==", "chess")
//     );
//     const unsub = onSnapshot(q, (snap) => {
//       if (!snap.empty) {
//         const game = snap.docs[0];
//         setCurrentGameId(game.id);
//         setWaitingGameId(null);
//         toast.success("Opponent found! Game started.");
//       }
//     });
//     return () => unsub();
//   }, [waitingGameId, user?.uid, setCurrentGameId]);

//   const canInvite = (u) =>
//     !busyUserIds.includes(u.userId) && !currentGameId && u.userId !== user.uid;
//   // --- Accept Invite ---
//   async function acceptChessInvite(invite, user, setCurrentGameId) {
//     const player1Username = invite.fromUsername || invite.from || "Player1";
//     const player1Avatar = invite.fromAvatar || "";
//     const player2Username = user.displayName || "Player2";
//     const player2Avatar = user.photoURL || "";

//     const gameRef = await addDoc(collection(db, "games"), {
//       type: "chess",
//       player1: {
//         userId: invite.from,
//         username: player1Username,
//         avatar: player1Avatar,
//       },
//       player2: {
//         userId: user.uid,
//         username: player2Username,
//         avatar: player2Avatar,
//       },
//       players: [invite.from, user.uid],
//       moves: [],
//       status: "active",
//       winner: null,
//       turn: "w",
//       betAmount: invite.betAmount,
//       createdAt: Date.now(),
//       updatedAt: Date.now(),
//       lastActive: {
//         [invite.from]: Date.now(),
//         [user.uid]: Date.now(),
//       },
//     });

//     await updateDoc(doc(db, "invites", invite.inviteId), {
//       status: "accepted",
//     });
//     setCurrentGameId(gameRef.id);
//   }

//   // --- Handle Quick Play / Waiting Room Logic ---
//   async function handleQuickPlay(betAmount) {
//     if (!user?.uid) return toast.error("Not logged in!");
//     if (betAmount < 0.5) return toast.error("Minimum bet is 0.5 USDT!");
//     if (betAmount > balance) return toast.error("Insufficient balance!");
//     if (isWaitingForQuickPlay) {
//       toast.error("You are already in Quick Play waiting room!");
//       return;
//     }
//     const userRef = doc(db, "users", user.uid);
//     await runTransaction(db, async (transaction) => {
//       const docSnap = await transaction.get(userRef);
//       const bal = docSnap.data().balance || 0;
//       if (bal < betAmount) throw new Error("Insufficient balance!");
//       transaction.update(userRef, { balance: +(bal - betAmount).toFixed(2) });
//     });

//     const waitQ = query(
//       collection(db, "waiting_games"),
//       where("betAmount", "==", betAmount),
//       where("gameType", "==", "chess")
//     );
//     const waitSnap = await getDocs(waitQ);
//     const otherPlayerDoc = waitSnap.docs.find((d) => d.data().uid !== user.uid);

//     if (otherPlayerDoc) {
//       const other = otherPlayerDoc.data();
//       const players = [
//         { userId: user.uid, username: user.displayName, avatar: user.photoURL },
//         { userId: other.uid, username: other.username, avatar: other.avatar },
//       ];
//       // QUICK PLAY: always set waiting player as player1/White
//       // const other = otherPlayerDoc.data();
//       const gameRef = await addDoc(collection(db, "games"), {
//         type: "chess",
//         player1: {
//           userId: other.uid, // waiting player is White
//           username: other.username,
//           avatar: other.avatar,
//         },
//         player2: {
//           userId: user.uid, // joining user is Black
//           username: user.displayName,
//           avatar: user.photoURL,
//         },
//         players: [other.uid, user.uid],
//         moves: [],
//         status: "active",
//         winner: null,
//         turn: "w",
//         betAmount: betAmount,
//         createdAt: Date.now(),
//         updatedAt: Date.now(),
//         lastActive: {
//           [other.uid]: Date.now(),
//           [user.uid]: Date.now(),
//         },
//       });

//       await deleteDoc(doc(db, "waiting_games", otherPlayerDoc.id));
//       setCurrentGameId(gameRef.id);
//       setWaitingGameId(null);
//       toast.success("Opponent found! Game started.");
//     } else {
//       const docRef = await addDoc(collection(db, "waiting_games"), {
//         uid: user.uid,
//         username: user.displayName,
//         avatar: user.photoURL,
//         betAmount,
//         gameType: "chess",
//         createdAt: Date.now(),
//       });
//       setWaitingGameId(docRef.id);
//       toast("Waiting for opponent...");
//     }
//   }

//   // --- Cancel waiting: remove from waiting_games and refund ---
//   async function handleCancelWaiting() {
//     if (!waitingGameId) return;
//     try {
//       const docRef = doc(db, "waiting_games", waitingGameId);
//       const docSnap = await getDoc(docRef);
//       if (docSnap.exists() && docSnap.data().uid === user.uid) {
//         const betAmount = docSnap.data().betAmount || 0.5;
//         const userRef = doc(db, "users", user.uid);
//         await runTransaction(db, async (transaction) => {
//           const userSnap = await transaction.get(userRef);
//           const bal = userSnap.data().balance || 0;
//           transaction.update(userRef, {
//             balance: +(bal + betAmount).toFixed(2),
//           });
//         });
//         await deleteDoc(docRef);
//         setWaitingGameId(null);
//         toast("Left waiting room and refunded.");
//       }
//     } catch (err) {
//       toast.error("Error cancelling waiting room: " + (err?.message || err));
//     }
//   }

//   // --- UI ---
//   return (
//     <div className="flex min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-lime-950 flex-col md:flex-row md:pt-16">
//       {/* Waiting Room Modal */}
//       <WaitingRoomModal open={!!waitingGameId} onCancel={handleCancelWaiting} />

//       {/* Mobile Online Players */}
//       <div className="block md:hidden w-full bg-slate-900 px-3 pt-3 pb-2 shadow z-10">
//         <div className="flex items-center gap-3 overflow-x-auto">
//           <span className="text-lime-400 font-bold mr-2">Online Players:</span>
//           {onlineUsers.length === 0 && (
//             <span className="text-slate-400">No one online</span>
//           )}
//           <div className="flex flex-col md:flex-row gap-2">
//             {onlineUsers.map((u) => {
//               const isBusy = busyUserIds.includes(u.userId);
//               return (
//                 <div
//                   key={u.userId}
//                   className="flex items-center gap-2 px-2 py-1 rounded-full bg-slate-800"
//                 >
//                   <span className="w-7 h-7 rounded-full flex items-center justify-center font-bold text-white text-sm bg-lime-500 shrink-0">
//                     {u.avatar ? (
//                       <img
//                         src={u.avatar}
//                         alt={u.username}
//                         className="w-7 h-7 rounded-full object-cover"
//                       />
//                     ) : u.username ? (
//                       u.username[0].toUpperCase()
//                     ) : (
//                       "U"
//                     )}
//                   </span>
//                   <span className="text-white text-xs">{u.username}</span>
//                   <button
//                     className={`text-xs font-bold px-2 py-1 rounded-full ml-2
//                       ${
//                         isBusy
//                           ? "bg-gray-400 text-gray-800 cursor-not-allowed"
//                           : "bg-lime-400 text-slate-900"
//                       }
//                     `}
//                     style={{ minWidth: 52 }}
//                     disabled={isWaitingForQuickPlay || !canInvite(u) || isBusy}
//                     onClick={() => {
//                       setInviteTarget(u);
//                       setInviteModalOpen(true);
//                     }}
//                   >
//                     {isBusy ? "Busy" : "Invite"}
//                   </button>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {/* Desktop Sidebar */}
//       <div className="hidden md:block">
//         <UserSidebar
//           onlineUsers={onlineUsers}
//           onInvite={(u) => {
//             setInviteTarget(u);
//             setInviteModalOpen(true);
//           }}
//           currentGameId={currentGameId}
//           busyUserIds={busyUserIds}
//           user={user}
//           setInviteTarget={setInviteTarget}
//           setInviteModalOpen={setInviteModalOpen}
//         />
//       </div>

//       {/* Invite Modal */}
//       <InviteModal
//         open={inviteModalOpen}
//         onClose={() => setInviteModalOpen(false)}
//         maxBalance={balance}
//         onSend={(betAmount) => {
//           if (inviteTarget) {
//             onInvite(inviteTarget, betAmount);
//           }
//           setInviteModalOpen(false);
//           setInviteTarget(null);
//         }}
//       />

//       {/* Accept Invite Modal */}
//       <AcceptInviteModal
//         open={acceptModalOpen}
//         inviter={
//           pendingInviteData?.fromUsername || pendingInviteData?.from || ""
//         }
//         betAmount={pendingInviteData?.betAmount}
//         onAccept={async () => {
//           if (pendingInviteData?.inviteId) {
//             setAcceptModalOpen(false);
//             await acceptChessInvite(pendingInviteData, user, setCurrentGameId);
//             setPendingInviteData(null);
//             toast.success("Game started!");
//           }
//         }}
//         onDecline={async () => {
//           if (pendingInviteData?.inviteId) {
//             setAcceptModalOpen(false);
//             await updateDoc(doc(db, "invites", pendingInviteData.inviteId), {
//               status: "declined",
//             });
//             setPendingInviteData(null);
//             toast("Invite declined.");
//           }
//         }}
//         onClose={() => {
//           setAcceptModalOpen(false);
//           setPendingInviteData(null);
//         }}
//       />

//       {/* Main content */}
//       <main className="flex-1 flex flex-col items-center justify-center p-4 md:p-8">
//         {vsComputer ? (
//           <ChessGameVsComputer
//             user={user}
//             onBack={() => setVsComputer(false)}
//           />
//         ) : !currentGameId ? (
//           <div className="w-full flex flex-col items-center justify-center gap-5 mt-10">
//             <div className="flex flex-col gap-4 items-center w-full max-w-xs">
//               <button
//                 className="
//                   w-full
//                   flex items-center justify-center
//                   bg-gradient-to-r from-lime-400 via-lime-500 to-green-500
//                   text-white font-extrabold text-lg
//                   px-8 py-4 rounded-2xl shadow-xl
//                   hover:scale-105 hover:shadow-2xl transition-all duration-200
//                   ring-2 ring-lime-300/30 focus:outline-none
//                 "
//                 disabled={isWaitingForQuickPlay}
//                 onClick={() => handleQuickPlay(0.5)}
//                 style={{ letterSpacing: "0.03em" }}
//               >
//                 <span className="drop-shadow">🎲 Quick Play</span>
//               </button>
//               <button
//                 className="
//                   w-full
//                   flex items-center justify-center
//                   bg-slate-800
//                   text-lime-400 font-bold text-lg
//                   px-8 py-4 rounded-2xl shadow-lg
//                   hover:bg-slate-700 hover:scale-105 hover:shadow-2xl
//                   transition-all duration-200
//                   ring-1 ring-slate-600/30 focus:outline-none
//                 "
//                 onClick={() => setVsComputer(true)}
//                 style={{ letterSpacing: "0.02em" }}
//               >
//                 <span className="drop-shadow">🤖 Play vs Computer</span>
//               </button>
//             </div>
//             <div className="text-xs text-slate-400 mt-2 italic">
//               Minimum bet:{" "}
//               <span className="text-lime-400 font-semibold">0.5 USDT</span> per
//               game.
//             </div>
//           </div>
//         ) : (
//           <ChessGameRoom
//             gameId={currentGameId}
//             user={user}
//             setCurrentGameId={setCurrentGameId}
//           />
//         )}
//       </main>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import UserSidebar from "./UserSidebar";
import InviteModal from "../../components/InviteModal";
import AcceptInviteModal from "../../components/AcceptInviteModal";
import ChessGameRoom from "./ChessGameRoom";
import ChessGameVsComputer from "./ChessGameVsComputer";
import toast from "react-hot-toast";
import {
  doc,
  updateDoc,
  getDoc,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  runTransaction,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";

// --- Waiting Room Modal ---
function WaitingRoomModal({ open, onCancel }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="bg-slate-900 rounded-2xl border-2 border-lime-400 p-8 max-w-xs w-full flex flex-col items-center">
        <div className="text-lime-400 font-bold text-xl mb-2">
          Waiting for Opponent...
        </div>
        <div className="mb-3 text-slate-200">
          You'll be matched automatically when another player enters the same
          bet.
        </div>
        <button
          onClick={onCancel}
          className="w-full bg-slate-700 hover:bg-slate-800 text-white rounded-xl px-6 py-2 mt-2"
        >
          Cancel & Leave Waiting Room
        </button>
      </div>
    </div>
  );
}

// --- Bet Modal for Play vs Computer ---
function BetModal({ open, onClose, maxBalance, onSend }) {
  const [betAmount, setBetAmount] = useState(0.5);
  return !open ? null : (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="bg-slate-900 rounded-2xl border-2 border-lime-400 p-7 max-w-xs w-full flex flex-col items-center">
        <div className="text-lime-400 font-bold text-lg mb-2">
          Play vs Computer
        </div>
        <input
          type="number"
          step="0.01"
          min={0.5}
          max={maxBalance || 100}
          value={betAmount}
          onChange={(e) => setBetAmount(Number(e.target.value))}
          className="w-full px-3 py-2 mb-4 text-lg rounded-lg bg-slate-800 text-white border-2 border-lime-400 focus:outline-none text-center"
        />
        <div className="text-slate-300 mb-4 text-xs">
          Minimum: 0.5 USDT. Your Balance:{" "}
          <span className="text-lime-400 font-bold">
            {maxBalance?.toFixed(2)}
          </span>
        </div>
        <div className="flex gap-2 w-full">
          <button
            className="flex-1 bg-slate-700 text-white rounded-xl py-2 font-semibold hover:bg-slate-800 transition"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-lime-400 text-[#161f2b] font-bold rounded-xl py-2 hover:bg-lime-300 transition"
            disabled={betAmount < 0.5 || betAmount > maxBalance}
            onClick={() => onSend(betAmount)}
          >
            Start
          </button>
        </div>
      </div>
    </div>
  );
}

export default function ChessLobbyPage({
  onlineUsers,
  invites,
  onInvite,
  onDecline,
  currentGameId,
  user,
  setCurrentGameId,
  busyUserIds = [],
  balance,
}) {
  // --- State ---
  const [vsComputer, setVsComputer] = useState(false);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [inviteTarget, setInviteTarget] = useState(null);
  const [acceptModalOpen, setAcceptModalOpen] = useState(false);
  const [pendingInviteData, setPendingInviteData] = useState(null);
  const [waitingGameId, setWaitingGameId] = useState(null);
  const [betModalOpen, setBetModalOpen] = useState(false);
  const [botBetAmount, setBotBetAmount] = useState(0.5);

  const isWaitingForQuickPlay = !!waitingGameId;

  // --- Accept Modal for invites sent to you ---
  useEffect(() => {
    if (invites && invites.length > 0) {
      const chessPendingInvite = invites
        .filter(
          (inv) =>
            inv.status === "pending" &&
            inv.to === user.uid &&
            inv.gameType === "chess"
        )
        .sort((a, b) => b.createdAt - a.createdAt)[0];
      if (
        chessPendingInvite &&
        (!pendingInviteData ||
          pendingInviteData.inviteId !== chessPendingInvite.inviteId)
      ) {
        setPendingInviteData(chessPendingInvite);
        setAcceptModalOpen(true);
      }
    }
  }, [invites, user, pendingInviteData]);

  // --- Listen for being matched while waiting ---
  useEffect(() => {
    if (!waitingGameId || !user?.uid) return;
    const q = query(
      collection(db, "games"),
      where("players", "array-contains", user.uid),
      where("status", "==", "active"),
      where("type", "==", "chess")
    );
    const unsub = onSnapshot(q, (snap) => {
      if (!snap.empty) {
        const game = snap.docs[0];
        setCurrentGameId(game.id);
        setWaitingGameId(null);
        toast.success("Opponent found! Game started.");
      }
    });
    return () => unsub();
  }, [waitingGameId, user?.uid, setCurrentGameId]);

  // --- Play vs Computer: Deduct balance before start ---
  const handleStartBotGame = async (betAmount) => {
    if (betAmount < 0.5) {
      toast.error("Minimum bet is 0.5 USDT!");
      return;
    }
    if ((balance || 0) < betAmount) {
      toast.error("Insufficient balance!");
      return;
    }
    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);
    const currentBalance = userSnap.data().balance || 0;
    if (currentBalance < betAmount) {
      toast.error("Insufficient balance!");
      return;
    }
    await updateDoc(userRef, {
      balance: +(currentBalance - betAmount).toFixed(2),
    });
    setBotBetAmount(betAmount);
    setBetModalOpen(false);
    setVsComputer(true);
  };

  async function sendChessInvite(fromUser, toUser, betAmount) {
    await addDoc(collection(db, "invites"), {
      from: fromUser.uid,
      fromUsername: fromUser.displayName,
      fromAvatar: fromUser.photoURL || "",
      to: toUser.userId,
      status: "pending",
      betAmount,
      gameType: "chess",
      createdAt: Date.now(),
    });
  }

  // --- Invite logic ---
  const canInvite = (u) =>
    !busyUserIds.includes(u.userId) && !currentGameId && u.userId !== user.uid;

  // --- Accept Invite ---
  async function acceptChessInvite(invite, user, setCurrentGameId) {
    const p1Ref = doc(db, "users", invite.from); // Inviter
    const p2Ref = doc(db, "users", user.uid); // Invitee
    const bet = Number(invite.betAmount || 0.5);

    // Atomic transaction to deduct from both
    await runTransaction(db, async (transaction) => {
      const p1Snap = await transaction.get(p1Ref);
      const p2Snap = await transaction.get(p2Ref);
      if (!p1Snap.exists() || !p2Snap.exists()) throw "User missing";
      const p1Bal = p1Snap.data().balance || 0;
      const p2Bal = p2Snap.data().balance || 0;
      if (p1Bal < bet || p2Bal < bet)
        throw `Both players need at least ${bet} USDT`;
      transaction.update(p1Ref, { balance: +(p1Bal - bet).toFixed(2) });
      transaction.update(p2Ref, { balance: +(p2Bal - bet).toFixed(2) });
    });

    const gameRef = await addDoc(collection(db, "games"), {
      type: "chess",
      player1: {
        userId: invite.from,
        username: invite.fromUsername,
        avatar: invite.fromAvatar || "",
      },
      player2: {
        userId: user.uid,
        username: user.displayName,
        avatar: user.photoURL || "",
      },
      players: [invite.from, user.uid],
      moves: [],
      status: "active",
      winner: null,
      turn: "w",
      betAmount: invite.betAmount,
      createdAt: Date.now(),
      updatedAt: Date.now(),
      lastActive: {
        [invite.from]: Date.now(),
        [user.uid]: Date.now(),
      },
    });

    // Update invite status
    await updateDoc(doc(db, "invites", invite.inviteId), {
      status: "accepted",
    });

    // Set as current game
    setCurrentGameId(gameRef.id);
  }

  // --- Quick Play / Waiting Room Logic ---
  async function handleQuickPlay(betAmount) {
    if (!user?.uid) return toast.error("Not logged in!");
    if (betAmount < 0.5) return toast.error("Minimum bet is 0.5 USDT!");
    if (betAmount > balance) return toast.error("Insufficient balance!");
    if (isWaitingForQuickPlay) {
      toast.error("You are already in Quick Play waiting room!");
      return;
    }
    const userRef = doc(db, "users", user.uid);
    await runTransaction(db, async (transaction) => {
      const docSnap = await transaction.get(userRef);
      const bal = docSnap.data().balance || 0;
      if (bal < betAmount) throw new Error("Insufficient balance!");
      transaction.update(userRef, { balance: +(bal - betAmount).toFixed(2) });
    });

    const waitQ = query(
      collection(db, "waiting_games"),
      where("betAmount", "==", betAmount),
      where("gameType", "==", "chess")
    );
    const waitSnap = await getDocs(waitQ);
    const otherPlayerDoc = waitSnap.docs.find((d) => d.data().uid !== user.uid);

    if (otherPlayerDoc) {
      const other = otherPlayerDoc.data();
      const players = [
        { userId: user.uid, username: user.displayName, avatar: user.photoURL },
        { userId: other.uid, username: other.username, avatar: other.avatar },
      ];
      const gameRef = await addDoc(collection(db, "games"), {
        type: "chess",
        player1: {
          userId: other.uid, // waiting player is White
          username: other.username,
          avatar: other.avatar,
        },
        player2: {
          userId: user.uid, // joining user is Black
          username: user.displayName,
          avatar: user.photoURL,
        },
        players: [other.uid, user.uid],
        moves: [],
        status: "active",
        winner: null,
        turn: "w",
        betAmount: betAmount,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        lastActive: {
          [other.uid]: Date.now(),
          [user.uid]: Date.now(),
        },
      });

      await deleteDoc(doc(db, "waiting_games", otherPlayerDoc.id));
      setCurrentGameId(gameRef.id);
      setWaitingGameId(null);
      toast.success("Opponent found! Game started.");
    } else {
      const docRef = await addDoc(collection(db, "waiting_games"), {
        uid: user.uid,
        username: user.displayName,
        avatar: user.photoURL,
        betAmount,
        gameType: "chess",
        createdAt: Date.now(),
      });
      setWaitingGameId(docRef.id);
      toast("Waiting for opponent...");
    }
  }

  // --- Cancel waiting: remove from waiting_games and refund ---
  async function handleCancelWaiting() {
    if (!waitingGameId) return;
    try {
      const docRef = doc(db, "waiting_games", waitingGameId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists() && docSnap.data().uid === user.uid) {
        const betAmount = docSnap.data().betAmount || 0.5;
        const userRef = doc(db, "users", user.uid);
        await runTransaction(db, async (transaction) => {
          const userSnap = await transaction.get(userRef);
          const bal = userSnap.data().balance || 0;
          transaction.update(userRef, {
            balance: +(bal + betAmount).toFixed(2),
          });
        });
        await deleteDoc(docRef);
        setWaitingGameId(null);
        toast("Left waiting room and refunded.");
      }
    } catch (err) {
      toast.error("Error cancelling waiting room: " + (err?.message || err));
    }
  }

  // --- UI ---
  return (
    <div className="flex min-h-screen w-full bg-gradient-to-br from-slate-950 via-slate-900 to-lime-950 flex-col md:flex-row md:pt-16">
      {/* Waiting Room Modal */}
      <WaitingRoomModal open={!!waitingGameId} onCancel={handleCancelWaiting} />

      {/* Mobile Online Players */}
      <div className="block md:hidden w-full bg-slate-900 px-3 pt-3 pb-2 shadow z-10">
        <div className="flex items-center gap-3 overflow-x-auto">
          <span className="text-lime-400 font-bold mr-2">Online Players:</span>
          {onlineUsers.length === 0 && (
            <span className="text-slate-400">No one online</span>
          )}
          <div className="flex flex-col md:flex-row gap-2">
            {onlineUsers.map((u) => {
              const isBusy = busyUserIds.includes(u.userId);
              return (
                <div
                  key={u.userId}
                  className="flex items-center gap-2 px-2 py-1 rounded-full bg-slate-800"
                >
                  <span className="w-7 h-7 rounded-full flex items-center justify-center font-bold text-white text-sm bg-lime-500 shrink-0">
                    {u.avatar ? (
                      <img
                        src={u.avatar}
                        alt={u.username}
                        className="w-7 h-7 rounded-full object-cover"
                      />
                    ) : u.username ? (
                      u.username[0].toUpperCase()
                    ) : (
                      "U"
                    )}
                  </span>
                  <span className="text-white text-xs">{u.username}</span>
                  <button
                    className={`text-xs font-bold px-2 py-1 rounded-full ml-2
                      ${
                        isBusy
                          ? "bg-gray-400 text-gray-800 cursor-not-allowed"
                          : "bg-lime-400 text-slate-900"
                      }
                    `}
                    style={{ minWidth: 52 }}
                    disabled={isWaitingForQuickPlay || !canInvite(u) || isBusy}
                    onClick={() => {
                      setInviteTarget(u);
                      setInviteModalOpen(true);
                    }}
                  >
                    {isBusy ? "Busy" : "Invite"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Desktop Sidebar */}
      <div className="hidden md:block">
        <UserSidebar
          onlineUsers={onlineUsers}
          onInvite={(u) => {
            setInviteTarget(u);
            setInviteModalOpen(true);
          }}
          currentGameId={currentGameId}
          busyUserIds={busyUserIds}
          user={user}
          setInviteTarget={setInviteTarget}
          setInviteModalOpen={setInviteModalOpen}
        />
      </div>

      {/* Invite Modal */}
      <InviteModal
        open={inviteModalOpen}
        onClose={() => setInviteModalOpen(false)}
        maxBalance={balance}
        onSend={async (betAmount) => {
          if (inviteTarget) {
            await sendChessInvite(user, inviteTarget, betAmount);
          }
          setInviteModalOpen(false);
          setInviteTarget(null);
          toast.success("Invite sent!");
        }}
      />

      {/* Accept Invite Modal */}
      <AcceptInviteModal
        open={acceptModalOpen}
        inviter={
          pendingInviteData?.fromUsername || pendingInviteData?.from || ""
        }
        betAmount={pendingInviteData?.betAmount}
        onAccept={async () => {
          if (pendingInviteData?.inviteId) {
            setAcceptModalOpen(false);
            await acceptChessInvite(pendingInviteData, user, setCurrentGameId);
            setPendingInviteData(null);
            toast.success("Game started!");
          }
        }}
        onDecline={async () => {
          if (pendingInviteData?.inviteId) {
            setAcceptModalOpen(false);
            await updateDoc(doc(db, "invites", pendingInviteData.inviteId), {
              status: "declined",
            });
            setPendingInviteData(null);
            toast("Invite declined.");
          }
        }}
        onClose={() => {
          setAcceptModalOpen(false);
          setPendingInviteData(null);
        }}
        gameType={pendingInviteData?.gameType}
      />

      {/* Play vs Computer Bet Modal */}
      <BetModal
        open={betModalOpen}
        onClose={() => setBetModalOpen(false)}
        maxBalance={balance}
        onSend={handleStartBotGame}
      />

      {/* Main content */}
      <main className="flex-1 flex flex-col items-center justify-center p-4 md:p-8">
        {vsComputer ? (
          <ChessGameVsComputer
            user={user}
            betAmount={botBetAmount}
            onBack={() => setVsComputer(false)}
          />
        ) : !currentGameId ? (
          <div className="w-full flex flex-col items-center justify-center gap-5 mt-10">
            <div className="flex flex-col gap-4 items-center w-full max-w-xs">
              <button
                className="
                  w-full
                  flex items-center justify-center
                  bg-gradient-to-r from-lime-400 via-lime-500 to-green-500
                  text-white font-extrabold text-lg
                  px-8 py-4 rounded-2xl shadow-xl
                  hover:scale-105 hover:shadow-2xl transition-all duration-200
                  ring-2 ring-lime-300/30 focus:outline-none
                "
                disabled={isWaitingForQuickPlay}
                onClick={() => handleQuickPlay(0.5)}
                style={{ letterSpacing: "0.03em" }}
              >
                <span className="drop-shadow">🎲 Quick Play</span>
              </button>
              <button
                className="
                  w-full
                  flex items-center justify-center
                  bg-slate-800
                  text-lime-400 font-bold text-lg
                  px-8 py-4 rounded-2xl shadow-lg
                  hover:bg-slate-700 hover:scale-105 hover:shadow-2xl
                  transition-all duration-200
                  ring-1 ring-slate-600/30 focus:outline-none
                "
                onClick={() => setBetModalOpen(true)}
                style={{ letterSpacing: "0.02em" }}
              >
                <span className="drop-shadow">🤖 Play vs Computer</span>
              </button>
            </div>
            <div className="text-xs text-slate-400 mt-2 italic">
              Minimum bet:{" "}
              <span className="text-lime-400 font-semibold">0.5 USDT</span> per
              game.
            </div>
          </div>
        ) : (
          <ChessGameRoom
            gameId={currentGameId}
            user={user}
            setCurrentGameId={setCurrentGameId}
            handleInvite={sendChessInvite}
          />
        )}
      </main>
    </div>
  );
}
